import React from 'react'
import { withRouter, Link } from "react-router-dom";
import { Container, Nav, Navbar, Button } from 'react-bootstrap'
import * as Cookies from "es-cookie";
import './_navbars.scss';

// Outlined pills on the white exam bar.
const pillStyle = (color) => ({ background: 'transparent', color, border: `1px solid ${color}` });

// "Analysis" goes to the result page matching how the exam was taken.
function analysisLink(type, locdata, history) {
    if (type == "pexam") {
        const state = history.location.state || {};
        return {
            pathname: "/student/subject/practice-result",
            state: { sessionid: locdata.sessionid, type: locdata.type, getData: state.getData, stype: locdata.stype }
        };
    }
    const pathname = type == "customp" ? "/student/subject/custompractice-result" : "/student/subject/exam-result";
    return { pathname, state: { sessionid: locdata.sessionid, type: locdata.type, examtype: locdata.examtype, stype: locdata.stype } };
}

/**
 * Header for the post-exam "Question and Answers View": the white exam bar
 * used on the exam screens (no profile menu or greeting), with links to the
 * exam's Analysis and Error Analysis.
 *
 * Props: onClick (sidebar toggle), type ("pexam" | "customp" | other),
 * locdata ({ sessionid, type, examtype, stype, htype }).
 */
function ExamHistoryNavbar({ onClick, type, locdata = {}, history }) {
    const institution24 = parseInt(Cookies.get("institution_id")) == 24;
    // Opened from exam history, the analysis is already one step back.
    const showAnalysis = locdata.htype != "history" && !(institution24 && type != "pexam" && type != "customp");
    const showErrorAnalysis = !institution24 && type !== "pexam";

    return (
        <Navbar bg="white" className="examtop-header header-top shadow-sm" expand="md">
            <Container>
                <div className="nav-brand">
                    <Button variant="light" className="px-2 py-1 mr-2" onClick={() => onClick()}>
                        <i className="fal fa-bars" />
                    </Button>
                </div>
                <Navbar.Toggle aria-controls="exam-history-navbar" />
                <Navbar.Collapse id="exam-history-navbar">
                    <div className="mr-auto">
                        <Button variant="link text-dark" onClick={history.goBack}>
                            <i className="fas fa-long-arrow-alt-left mr-2" />Go Back
                        </Button>
                    </div>
                    <Nav className="mx-auto">
                        <h6 className="title text-muted mr-3 mb-0">Question and Answers View</h6>
                    </Nav>
                    <Nav className="ml-auto align-items-center">
                        {showAnalysis ? (
                            <Link to={analysisLink(type, locdata, history)} className="d-flex align-items-center rounded-pill btn px-5 py-2 mr-2" style={pillStyle('#212B65')}>
                                Analysis
                            </Link>
                        ) : null}
                        {showErrorAnalysis ? (
                            <Link to={{ pathname: "/student/exam/error-analysis", state: { sessionid: locdata.sessionid } }} className="d-flex align-items-center rounded-pill btn px-5 py-2" style={pillStyle('#ff0000')}>
                                Error Analysis
                            </Link>
                        ) : null}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default withRouter(ExamHistoryNavbar);
